<template>
  <div>
    <c-row class="mb-2">
      <c-col>
        <h2>Email logs</h2>
      </c-col>
      <c-col>
        <c-button
          v-if="!isLoading"
          color="primary"
          class="float-right"
          :class="{ 'is-loading': isLoading }"
          @click="get"
        >
          <span class="icon"><i class="fa fa-refresh" /></span>
          <span>Refresh</span>
        </c-button>
      </c-col>
    </c-row>

    <template v-if="isLoading">
      <p class="text-h6 is-4">
        Loading...
        <c-spinner color="success" size="sm" />
      </p>
    </template>
    <template v-else>
      <table v-if="clientEmailLogs.length" class="table">
        <thead>
          <tr>
            <th class="date">Date</th>
            <th>Success</th>
            <th>Recipient</th>
            <th>Email Opened</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in clientEmailLogs">
            <td>{{ log.createdAt | dateFormat }}</td>
            <td>{{ log.success ? 'Yes' : 'No' }}</td>
            <td>{{ log.recipient }}</td>
            <td v-if="!log.emailOpened" class="">{{ log.emailOpened ? log.emailOpenedDate : 'No' }}</td>
            <td v-if="log.emailOpened">{{ log.emailOpenedDate | dateFormat }}</td>
            <td class="has-text-right">
              <c-button v-if="log.html" color="primary" @click="viewEmail(log.html)">View message</c-button>
            </td>
          </tr>
        </tbody>
      </table>
      <h3 v-else class="h4 subtitle mb-4 text-muted">No emails have been sent to this client.</h3>
    </template>
    <confirm-modal
      size="lg"
      title="Update All Plugins"
      :show.sync="showHtmlMessage"
      cancel-text="Close"
      :hide-confirm="true"
      @update:confirm="closePreview"
    >
      <div class="message-view" v-html="htmlMessage" />
    </confirm-modal>
  </div>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';
import ConfirmModal from '@/views/components/ConfirmModal';

export default {
  components: {
    ConfirmModal,
  },

  props: {
    client: Object,
  },
  data() {
    return {
      error: null,
      clientEmailLogs: [],
      isLoading: false,
      emailContent: '',
      showHtmlMessage: false,
      htmlMessage: '',
    };
  },

  created() {
    this.get();
  },

  methods: {
    get() {
      this.isLoading = true;
      this.error = null;
      this.$http
        .get(buildEndpoint('clients/get/email-logs/') + this.client._id)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.clientEmailLogs = response.data.data;
          } else {
            this.error = 'Error getting log data';
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    closePreview() {
      this.showHtmlMessage = false;
    },
    viewEmail(content) {
      this.htmlMessage = content;
      this.showHtmlMessage = true;
    },
  },
};
</script>

<style lang="scss" scoped="">
table {
  .date {
    width: 200px;
  }
}
.no-logs {
  margin-top: 20px;
}
.message-view {
  background-color: white !important;
  color: black;
}
</style>
